import http from "@/utils/httpRequest";

/**
 * 获得文章分类列表
 *
 */
export function getArticleCategoryList() {
  return http.get(http.adornUrl(`/cms/category/list`));
}
/**
 * 获得文章列表
 *
 */
export function getArticleList(params) {
  return http.get(
    http.adornUrl(
      `/cms/article/list?code=${params.code}&page=${params.page}&limit=${params.limit}`
    )
  );
}
/**
 * 获得文章详情
 * @param {*} id
 */
export function getArticleDetails(id) {
  return http.get(http.adornUrl(`/cms/article/detail/${id}`));
}



// WEBPACK FOOTER //
// ./src/api/api.js